import React from 'react'
import { withAuthorization } from '../session';
import OfferItem from './OfferItem';
import Loader from 'react-loader-spinner';
import Modal from 'react-modal';
import modalStyle from '../styles/modal'
import EmptyList from '../useful/EmptyList';
import OfferForm from './OfferForm';

Modal.setAppElement('#root');
class Offer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            offers: [],
            error: {
                isShow: false,
                message: ''
            }
        }
    }

    componentDidMount() {
        this.setState({ loading: true });
        this.listenOffers();
    }

    componentWillUnmount() {
        this.props.firebase.offers().off();
    }

    listenOffers = () => {
        this.props.firebase.offers().off();
        this.props.firebase.offers().on('value', (snapshot) => {
            const offerObject = snapshot.val();
            let list = [];
            if (offerObject) {
                list = Object.keys(offerObject).map(key => ({
                    ...offerObject[key],
                    uid: key,
                }));
            }
            this.setState({
                offers: list,
                loading: false,
            });

        });
    }

    handleUploadFile = (fileUrl, item) => {
        this.props.firebase.offer(item.uid)
            .set({
                title: item.title,
                latitude: item.latitude || null,
                longitude: item.longitude || null,
                fileUrl: fileUrl,
            })
            .then(() => {
                // do nothing
            })
            .catch(error => {
                this.showErrorModal("Los sentimos, ocurrió un error al subir el archivo.");
            });
    }

    handleSubmit = (title, latitude, longitude) => {
        this.props.firebase.offers().push({
            title: title,
            latitude: parseFloat(latitude),
            longitude: parseFloat(longitude)
        }).then(() => {
            // do nothing
        }).catch(error => {
            this.showErrorModal("Los sentimos, no se pudo crear este elemento.");
            console.log(error);
        });
    }

    handleDelete = (item) => {
        const itemUid = item.uid;

        this.props.firebase.offer(itemUid).remove()
            .then(() => {
                // do nothing
            })
            .catch(error => {
                this.showErrorModal("Los sentimos, no se pudo eliminar este elemento.");
                console.log(error);
            });
    }

    showErrorModal = (message) => {
        this.setState({
            error: {
                isShow: true,
                message: message
            }
        });
    }

    closeErrorModal = () => {
        this.setState({
            error: {
                isShow: false,
                message: ''
            }
        });
    }

    render() {
        const { offers, loading, error } = this.state;

        const time = new Date().getTime();
        const offerList = offers.length > 0 ?
            offers.map((item, i) => {
                return (
                    <OfferItem
                        key={item.uid + time}
                        item={item}
                        handleDelete={this.handleDelete}
                        handleUploadFile={this.handleUploadFile}
                        showErrorModal={this.showErrorModal}
                    />
                )
            }) :
            <tr>
                <td colSpan="10">
                    <EmptyList />
                </td>
            </tr>
        return (
            <div >
                <OfferForm key={time} handleSubmit={this.handleSubmit} />

                <div>
                    <h5 >Comisión de ofrecimiento:</h5>

                    {(!loading) ?
                        <div className="table-responsive-md">
                            <table className="table table-sm ">
                                <thead className="thead-dark">
                                    <tr>
                                        <th className="pr-2 pl-2" scope="col">Título</th>
                                        <th className="pr-2 pl-2 text-center" scope="col">Ubicación</th>
                                        <th className="pr-2 pl-2" scope="col">Archivo</th>
                                        <th className="pr-2 pl-2 text-right" scope="col">Opciones</th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontSize: '0.9em' }}>
                                    {offerList}
                                </tbody>
                            </table>
                        </div>
                        :
                        <div className="nav justify-content-center row">
                            <Loader className="mt-4"
                                type="ThreeDots"
                                color="#263238"
                                height={60}
                                width={60}
                                timeout={0} />
                        </div>
                    }
                </div>

                <Modal
                    isOpen={error.isShow}
                    contentLabel="Modal Example"
                    style={modalStyle}
                    onRequestClose={this.closeErrorModal}>
                    <div className="" style={{ minWidth: '300px', maxWidth: '400px' }}>
                        <h5 className="card-title">Error</h5>
                        <p className="card-text text-break">{error.message}</p>

                        <div className="nav justify-content-end">
                            <button onClick={this.closeErrorModal} className="btn btn-sm btn-dark">Cerrar</button>
                        </div>
                    </div>

                </Modal>
            </div>
        );
    }

}

const condition = authUser => !!authUser;
export default withAuthorization(condition)(Offer);